// Inspired from sms-length typescript lib
// https://www.npmjs.com/package/sms-length

const GSM_7_BIT_REGEXP = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà]*$/
const GSM_7_BIT_EXT_REGEXP = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~\]|€]*$/
const GSM_7_BIT_EXT_CHAR_REGEXP = /[\^{}\\[~\]|€]/g

// Unsupported GSM Characters
const GSM_UNSUPPORTED_MAP = [
  '`', '¨', '«', '´', '»', 'À', 'Á', 'Â', 'È', 'Ê', 'Ë', 'Ì', 'Í', 'Î', 'Ï', 'Ò',
  'Ó', 'Ô', 'Ù', 'Ú', 'Û', 'à', 'á', 'â', 'ê', 'ë', 'е', 'í', 'î', 'ï', 'ó', 'ô',
  '÷', 'ú', 'û', 'ă', 'ı', 'Œ', 'œ', 'Ş', 'ǃ', 'Ș', 'ș', 'Ț', 'ț', 'ɢ', 'ɪ', 'ɴ',
  'ʀ', 'ʏ', 'ʙ', 'ʜ', 'ʟ', 'ʹ', 'ʺ', 'ʻ', 'ʼ', 'ʽ', 'ˆ', 'ˈ', 'ˊ', 'ˋ', 'ː', '˖',
  '˜', 'ˮ', '˷', '˸', '̂', '̃', '̓', '̔', '̦', '̰', '̲', '̴', '̷', '̸', '͇', 'Ά',
  'Έ', 'Ή', 'Ί', 'Ό', 'Ύ', 'Ώ', 'ΐ', 'Α', 'Β', 'Ε', 'Ζ', 'Η', 'Ι', 'Κ', 'Μ', 'Ν',
  'Ο', 'Ρ', 'Τ', 'Υ', 'Χ', 'Ϊ', 'Ϋ', 'ά', 'έ', 'ή', 'ί', 'ΰ', 'α', 'β', 'γ', 'δ',
  'ε', 'ζ', 'η', 'θ', 'ι', 'κ', 'λ', 'μ', 'ν', 'ξ', 'ο', 'π', 'ρ', 'ς', 'σ', 'τ',
  'υ', 'φ', 'χ', 'ψ', 'ω', 'ϊ', 'ϋ', 'ό', 'ύ', 'ώ', 'ᴀ', 'ᴄ', 'ᴅ', 'ᴇ', 'ᴊ', 'ᴋ',
  'ᴍ', 'М', 'ᴏ', 'ᴘ', 'ᴛ', 'ᴜ', 'ᴠ', 'ᴡ', 'ᴢ', '᷍', '‐', '–', '—', '―', '‗', '’',
  '‚', '‛', '“', '”', '„', '‟', '‹', '›', '⁃', '⁄', '⁎', '⁏', '⁠', '₤', '⃒', '⃓',
  '⃥', '∕', '∗', '∣', '∼', '⊛', '⎜', '⎟', '⎸', '⎹', '⎼', '⎽', '⏐', '✢', '✣', '✤',
  '✥', '✱', '✲', '✳', '✺', '✻', '✼', '✽', '❃', '❉', '❊', '❋', '❛', '❜', '❝',
  '❞', '❨', '❩', '❪', '❫', '❴', '❵', '⟮', '⟯', '⦂', '⦅', '⦆', '⧆', '⧵', '⧸', '⧹',
  '。', '〝', '〞', 'ꜰ', 'ꜱ', '꞉', '꞊', '︐', '︑', '︓', '︔', '︕', '︖', '﹐', '﹑', '﹒',
  '﹔', '﹖', '﹗', '﹙', '﹚', '﹛', '﹜', '﹟', '﹠', '﹡', '﹢', '﹣', '﹤', '﹥', '﹦', '﹨',
  '﹩', '﹪', '﹫', '！', '＂', '＃', '＄', '％', '＆', '＇', '（', '）', '＊', '＋', '，', '－',
  '．', '／', '０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '：', '；', '＜', '＝',
  '＞', '？', '＠', 'Ａ', 'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ',
  'Ｎ', 'Ｏ', 'Ｐ', 'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ', 'Ｚ', '［', '＼', '］',
  '＾', '＿', '｛', '｜', '｝', '～', '｡', '､', 'U+0000', 'U+0003', 'U+0004', 'U+0009',
  'U+0010', 'U+0011', 'U+0012', 'U+0013', 'U+0014', 'U+0017', 'U+0019', 'U+0080',
  'U+008D', 'U+0090', 'U+009B', 'U+009F', 'U+2000', 'U+2001', 'U+2002', 'U+2003',
  'U+2004', 'U+2005', 'U+2006', 'U+2007', 'U+2008', 'U+2009', 'U+2028', 'U+2029',
  'U+202F', 'U+205F', 'U+2060', 'U+3000'
]

const GSM_SUPPORTED_MAP = [
  '\'', '"', '"', '\'', '"', 'A', 'A', 'A', 'E', 'E', 'E', 'I', 'I', 'I', 'I', 'O',
  'O', 'O', 'U', 'U', 'U', 'a', 'a', 'a', 'e', 'e', 'e', 'i', 'i', 'i', 'o', 'o',
  '/', 'u', 'u', 'a', 'i', 'Ö', 'ö', 'S', '!', 'S', 's', 'T', 't', 'G', 'I', 'N',
  'R', 'Y', 'B', 'H', 'L', '\'', '"', '\'', '\'', '\'', '^', '\'', '\'', '\'', ':', '+',
  '~', '"', '~', ':', '^', '~', '\'', '\'', ',', '~', '_', '~', '/', '/', '=', 'A',
  'E', 'H', 'I', 'O', 'Y', 'Ω', 'I', 'A', 'B', 'E', 'Z', 'H', 'I', 'K', 'M', 'N',
  'O', 'P', 'T', 'Y', 'X', 'I', 'Y', 'A', 'E', 'H', 'I', 'Y', 'A', 'B', 'Γ', 'Δ',
  'E', 'Z', 'H', 'Θ', 'I', 'K', 'Λ', 'M', 'N', 'Ξ', 'O', 'Π', 'P', 'Σ', 'Σ', 'T',
  'Y', 'Φ', 'X', 'Ψ', 'Ω', 'I', 'Y', 'O', 'Y', 'Ω', 'A', 'C', 'D', 'E', 'J', 'K',
  'M', 'M', 'O', 'P', 'T', 'U', 'V', 'W', 'Z', '^', '-', '-', '-', '-', '_', '\'',
  ',', '\'', '"', '"', '"', '"', '>', '<', '-', '/', '*', ';', '', '£', '|', '|',
  '\\', '/', '*', '|', '~', '*', '|', '|', '|', '|', '-', '-', '|', '*', '*', '*',
  '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '\'', '\'', '"',
  '"', '(', ')', '(', ')', '{', '}', '(', ')', ':', '(', ')', '*', '\\', '/', '\\',
  '.', '"', '"', 'F', 'S', ':', '=', '\'', '\'', ':', ';', '!', '?', ',', ',', '.',
  ';', '?', '!', '(', ')', '{', '}', '#', '&', '*', '+', '-', '<', '>', '=', '\\',
  '$', '%', '@', '!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-',
  '.', '/', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ':', ';', '<', '=',
  '>', '?', '@', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '[', '\\', ']',
  '^', '_', '{', '|', '}', '~', '.', ','
]

const messageLength = {
  GSM_7_BIT    : 160,
  GSM_7_BIT_EXT: 160,
  UTF_16       : 70
}

const multiMessageLength = {
  GSM_7_BIT    : 153,
  GSM_7_BIT_EXT: 153,
  UTF_16       : 67
}

const isStdGsm = text => text.match(GSM_7_BIT_REGEXP) !== null

const isExtGsm = text => text.match(GSM_7_BIT_EXT_REGEXP) !== null

const isGsmCharset = text => isStdGsm(text) || isExtGsm(text)

export const convertToGsm = text => {
  if (isGsmCharset(text)) return text

  const textArray = text.split('')

  for (let i = 0; i < textArray.length; i++) {
    const char = textArray[i]
    if (!isGsmCharset(char)) {
      const charIndex = GSM_UNSUPPORTED_MAP.findIndex(c => c === char)
      if (charIndex > -1) {
        textArray[i] = GSM_SUPPORTED_MAP[charIndex]
      } else {
        textArray[i] = '?'
      }
    }
  }

  return textArray.join('')
}

const detectEncoding = text => {
  if (isStdGsm(text)) return 'GSM_7_BIT'
  if (isExtGsm(text)) return 'GSM_7_BIT_EXT'
  return 'UTF_16'
}

export const smsTextInfo = text => {
  const encoding = detectEncoding(text)
  const length =
    encoding === 'GSM_7_BIT_EXT'
      ? text.length + (text.match(GSM_7_BIT_EXT_CHAR_REGEXP) ?? []).length
      : text.length

  let characterPerMessage = messageLength[encoding]
  if (length > characterPerMessage) {
    characterPerMessage = multiMessageLength[encoding]
  }

  const messages = Math.ceil(length / characterPerMessage)

  const inCurrentMessage =
    messages > 0 ? length - characterPerMessage * (messages - 1) : length

  let remaining = characterPerMessage * messages - length
  if (remaining === 0 && messages === 0) {
    remaining = characterPerMessage
  }

  return {
    encoding,
    length,
    characterPerMessage,
    inCurrentMessage,
    remaining,
    messages
  }
}
